import React from 'react';
import CustomSelect from '../common/CustomSelect';
import { PublishedVersionSummary } from '../../types';

interface VersionSelectorProps {
  projectId: number;
  versions: PublishedVersionSummary[];
  selectedVersionId: number | null;
  onVersionSelect: (checkpointId: number | null) => void;
}

const VersionSelector: React.FC<VersionSelectorProps> = ({
  projectId,
  versions,
  selectedVersionId,
  onVersionSelect,
}) => {
  const handleChange = (value: string) => {
    if (value === 'latest') {
      onVersionSelect(null);
    } else {
      onVersionSelect(parseInt(value, 10));
    }
  };

  const selectedValue = selectedVersionId !== null ? String(selectedVersionId) : 'latest';

  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor={`version-selector-${projectId}`}
        className="text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Version
      </label>
      <CustomSelect
        value={selectedValue}
        onChange={handleChange}
        options={[
          { value: 'latest', label: 'Latest' },
          ...versions.map((version) => ({
            value: String(version.checkpoint_id),
            label: `${version.version_name}${version.published_at ? ` (${new Date(version.published_at).toLocaleDateString()})` : ''}`,
          })),
        ]}
        aria-label="Version"
      />
    </div>
  );
};

export default VersionSelector;
